
import { Positions } from '@mui/material';
import React from 'react';
import { Button } from '@mui/material';
import SVG from 'react-inlinesvg';
;

type Props = {
  onClick: () => void;
  tooltipLabel: string;
  svgPath: string;
  tooltipPosition?: Positions;
};

export default (props: Props) => {
  const { 
    onClick, 
    tooltipLabel, 
    svgPath,
    tooltipPosition = 'left',
  } = props;
  return (
    // <Button 
    //   tooltipPosition={tooltipPosition} 
    //   tooltipLabel={tooltipLabel} 
    //   onClick={onClick} 
    //   icon={true} 
    //   svg={true} 
    //   style={{ padding: '1px 7px 2px' }} 
    //   // this prevents from displaying too wide tooltips 
    //   // and rather wraps the text inside
    //   tooltipStyle={{
    //     width: '75px',
    //     whiteSpace: 'normal',
    //   }}
    // >
    //   <SVG style={{ width: '24px', fill: 'black' }} className={'roofs-selector-control-panel-active'} src={svgPath} />
    // </Button>
    // Using MUI Button instead of react-md Button because it has better support for tooltips.
    <Button 
      variant="text" 
      title={tooltipLabel} 
      onClick={onClick} 
      className="roofs-selector-control-panel-active"
      style={{ padding: '1px 7px 2px' }}
    >
      <SVG style={{ width: '18px', height: '18px', fill: 'black' }} src={svgPath} />
    </Button>
  );
};
